$(document).ready(function() {

  var $testimonialsSlider = $('.testimonials .slick');
  
  if ($testimonialsSlider.length) {
    // slickInit($testimonialsSlider, false, true);
    $($testimonialsSlider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 8000,
      arrows: false
    });
  };
});